import * as React from 'react';
import { matchesSearchText } from '../utils/listSearch';

/** 絞り込みで行が1件も残らなかったときに、表の中に出す文 */
export const LIST_SEARCH_EMPTY_MESSAGE = '絞り込みの条件に合う行はありません';

export interface ListSearch {
  /** 絞り込みの欄に入っている文字 */
  text: string;
  setText: (text: string) => void;
  /** 絞り込みの文字が入っているか。絞り込んでいる間は並びを変えさせないために使う */
  filtering: boolean;
  /** 行の項目が絞り込みの文字に合うか */
  matches: (fields: Array<string | null | undefined>) => boolean;
}

/**
 * 一覧の絞り込みの状態を持つフック。絞り込みの欄は表のすぐ上（ListSummary）に置く。
 * 絞り込みの文字は保存せず、画面を開き直すと空に戻る
 */
export function useListSearch(): ListSearch {
  const [text, setText] = React.useState('');

  return {
    text,
    setText,
    filtering: text.trim() !== '',
    matches(fields) {
      return matchesSearchText(text, fields);
    },
  };
}
